__webpack_require__.p = "/claimsx-client/";